// src/components/BrandSection.jsx
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const BrandSection = () => {
  const brandLogos = Array.from({ length: 24 }, (_, i) => ({
    src: `/assets/img/brand/doi-tac-hop-tac-${String(i + 1).padStart(
      2,
      "0"
    )}.webp`,
    alt: `Đối tác ${i + 1}`,
  }));

  return (
    <div className="brand-section section-padding fix pt-0">
      <div className="container">
        <div className="brand-text mb-4">
          <h2 className="brand-text__heading">ĐỐI TÁC - KHÁCH HÀNG</h2>
        </div>

        <Swiper
          className="brand-slider"
          loop={true}
          modules={[Autoplay]}
          autoplay={{
            delay: 1,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          speed={3000}
          freeMode={true}
          breakpoints={{
            0: { slidesPerView: 1, spaceBetween: 20 },
            576: { slidesPerView: 3, spaceBetween: 30 },
            992: { slidesPerView: 4, spaceBetween: 40 },
            1200: { slidesPerView: 5, spaceBetween: 50 },
            1400: { slidesPerView: 6, spaceBetween: 60 },
          }}
        >
          {brandLogos.map((brand, index) => (
            <SwiperSlide key={index}>
              <div className="brand-card text-center">
                <div className="brand-image-wrapper">
                  <img
                    src={brand.src}
                    alt={brand.alt}
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default BrandSection;
